export const getRoutePathWithHash = route => {
  return route?.path?.concat(route.hash);
};
